import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import AdminLayout from './layouts/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import IncomePage from './pages/IncomePage';
import ExpensesPage from './pages/ExpensesPage';
import CoursesPage from './pages/CoursesPage';
import RentalsPage from './pages/RentalsPage';
import ReportsPage from './pages/ReportsPage';
import MonitorsPage from './pages/MonitorsPage';
import SettingsPage from './pages/SettingsPage';
import InventoryPage from './pages/InventoryPage';
import InvoicingPage from './pages/InvoicingPage';
import SchedulePage from './pages/SchedulePage';
import MonitorPortalPage from './pages/MonitorPortalPage';
import ExcelSkullPage from './pages/ExcelSkullPage';
import ReservationsPage from './pages/ReservationsPage';
import ConfirmPage from './pages/ConfirmPage';
import ShortLinkPage from './pages/ShortLinkPage';
import PayPage from './pages/PayPage';
import PaymentsAdminPage from './pages/PaymentsAdminPage';
import CRMPage from './pages/CRMPage';

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'admin') return <Navigate to="/admin" replace />;
  if (user.role === 'caseta') return <Navigate to="/admin/crm" replace />;
  return <Navigate to="/monitor" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<RootRedirect />} />
          
          {/* Admin + Caseta routes */}
          <Route path="/admin" element={
            <ProtectedRoute allowRoles={['admin', 'caseta']}>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<ReportsPage />} />
            <Route path="income" element={<IncomePage />} />
            <Route path="expenses" element={<ExpensesPage />} />
            <Route path="courses" element={<CoursesPage />} />
            <Route path="schedule" element={<SchedulePage />} />
            <Route path="rentals" element={<RentalsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="monitors" element={<MonitorsPage />} />
            <Route path="invoicing" element={<InvoicingPage />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="excel-skull" element={<ExcelSkullPage />} />
            <Route path="reservations" element={<ReservationsPage />} />
            <Route path="payments" element={<PaymentsAdminPage />} />
            <Route path="crm" element={<CRMPage />} />
          </Route>

          {/* Monitor route */}
          <Route path="/monitor" element={
            <ProtectedRoute>
              <MonitorPortalPage />
            </ProtectedRoute>
          } />

          {/* Public routes */}
          <Route path="/pay" element={<PayPage />} />
          <Route path="/c/:code" element={<ShortLinkPage />} />
          <Route path="/confirmar/:token" element={<ConfirmPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
